import { Injectable } from '@angular/core';
import { gql, Mutation } from 'apollo-angular';

import { PRODUCT_LINE_PRICING_FRAGMENT } from 'graphql/fragments/product-line-pricing';
import { QUOTE_PRICING_FRAGMENT } from 'graphql/fragments/quote-pricing';
import { QUOTE_PRICING_STATE_FRAGMENT } from 'graphql/fragments/quote-pricing-state';
import { Mutation as RootMutation } from 'graphql/models/generated';

export const REMOVE_PRICING_COMMANDS_MUTATION = gql`
  mutation removePricingCommands(
    $documentId: DocumentVersionInput!,
    $withPricing: Boolean = true,
    $excludeStepIds: [String]
  ) {
    custom {
      removePricingCommands(
        documentId: $documentId
        excludeStepIds: $excludeStepIds
      ) {
      documentId
      ...QuotePricingFragment @include(if: $withPricing)
      ...QuotePricingStateFragment @skip(if: $withPricing)
        lines {
          id
          ...ProductLinePricingFragment @include(if: $withPricing)
        }
      }
    }
  }
  ${QUOTE_PRICING_FRAGMENT}
  ${QUOTE_PRICING_STATE_FRAGMENT}
  ${PRODUCT_LINE_PRICING_FRAGMENT}
`;

@Injectable({
  providedIn: 'root'
})
export class RemovePricingCommandsMutation extends Mutation<RootMutation> {
  document = REMOVE_PRICING_COMMANDS_MUTATION;
}
